import React from "react"
import { closeIcon } from "../../../../../../static/svgs/agenda"
import { hamburger } from "../../../../../../static/svgs/navigation"

type Props = {
  isOpen: boolean
  onClick: () => void
}

const Hamburger = ({ isOpen, onClick }: Props) => {
  return (
    <img
      alt=""
      className={`cursor-pointer scale-50 ${isOpen ? "pl-3" : ""}`}
      src={isOpen ? closeIcon : hamburger}
      onClick={() => onClick()}
    />
  )
}

export default Hamburger
